import { render, staticRenderFns } from "./Yes.vue?vue&type=template&id=486fa21e&scoped=true"
import script from "./Yes.vue?vue&type=script&lang=js"
export * from "./Yes.vue?vue&type=script&lang=js"
import style0 from "./Yes.vue?vue&type=style&index=0&id=486fa21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486fa21e",
  null
  
)

export default component.exports